<div>
  <ng-container *ngFor="let lineItem of invoice.LineItems; index as i">
    <div *ngIf="lineItem.Payments" class="mb-50">
      <div *ngFor="let payment of lineItem.Payments; index as j">
        <wl-invoice-payment-edit
          [payment]="payment"
          [paymentTypes]="paymentTypes"
          [lineItem]="lineItem"
          [paymentSources]="paymentSources"
          [flatPaymentIds]="flatPaymentIds"
          (removeClicked)="removePayment(i, j)"
        ></wl-invoice-payment-edit>
        <!-- <hr /> -->
      </div>
    </div>
  </ng-container>
</div>
